<ion-grid
  class="list-banner"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
  [fixed]="true"
>
  <ion-row
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    class="my-lists"
  >
    <ion-col size="12">
      <ion-text data-cy="list-banner-my-lists-text">
        {{ 'i18n.lists.myLists' | translate | uppercase }}
      </ion-text>
    </ion-col>
  </ion-row>

  <ion-row class="ion-align-items-center">
    <ion-col
      class="list-info"
      [size]="
        platformService?.platformType === platformService?.platformEnum?.tablet
          ? 7.5
          : 11
      "
    >
      <div data-cy="list-banner-list-name-section" class="list-name-section">
        <h1 data-cy="list-banner-list-name-text" class="list-name-text">
          {{ listName | uppercase }}
        </h1>
      </div>
      <div
        data-cy="list-banner-num-products-section"
        class="num-products-section"
      >
        <span
          *ngIf="
            platformService?.platformType !==
              platformService?.platformEnum?.mobile;
            else mobileNumProducts
          "
          data-cy="list-banner-num-products-text"
        >
          {{ listItemCount }}&nbsp;
          {{
            (listItemCount !== 1 ? 'i18n.lists.products' : 'i18n.lists.product')
              | translate
          }}
        </span>
        <ng-template #mobileNumProducts>
          <span data-cy="list-banner-num-products-text">
            ({{ listItemCount }})
          </span>
        </ng-template>
      </div>
    </ion-col>

    <ion-col
      size="3.5"
      *ngIf="
        platformService?.platformType === platformService?.platformEnum?.tablet
      "
    >
      <ion-row *ngIf="listItemCount > 0" class="interact-download">
        <ion-label (click)="emitPrintClick($event)">
          <ion-icon name="print-outline"></ion-icon>
          {{ 'i18n.common.print' | translate }}
        </ion-label>
        <ion-label (click)="emitDownloadClick($event)">
          <ion-icon name="download-outline"></ion-icon>
          {{ 'i18n.common.download' | translate }}
        </ion-label>
      </ion-row>
    </ion-col>

    <!--
        Hide if we are on recent purchase, orderguide, customer is
        restriced to msl or if not restricted to msl and no secondaries exist
      -->
    <ion-col *ngIf="showEllipsis" size="1">
      <div data-cy="list-banner-ellipsis-section">
        <ion-icon
          data-cy="list-banner-ellipsis-icon"
          name="ellipsis-vertical"
          (click)="handleEllipsisClickEvent($event)"
        ></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
